/**
 * TÜKETİM RAPORU ÜRÜN GRUPLAMASI (kullanıcı kararı 2026-08-28)
 *
 * Firma detayı > Raporlar > Tüketim raporunda yalnızca üç ürün kendi adıyla
 * listelenir: Çay, Filtre Kahve, Türk Kahvesi. DİĞER HER ÜRÜN tek bir
 * "Espresso" satırında toplanır.
 *
 * Neden: espresso makinesi (X460PLUS / Kalerm) onlarca ayrı içecek adı
 * üretiyor (latte, cappuccino, çikolata, americano...). Bunların her biri
 * ayrı satır olunca rapor okunmaz hale geliyordu. Kırılım gerektiğinde
 * cihaz raporundan bakılır.
 *
 * Karşılaştırma Türkçe locale ile yapılır: "ÇAY"/"çay" gibi varyasyonlar da
 * eşleşsin, ama İ/ı tuzağına düşülmesin.
 */

export const CORE_CONSUMPTION_PRODUCTS = ["Çay", "Filtre Kahve", "Türk Kahvesi"];

export const ESPRESSO_GROUP_LABEL = "Espresso";

/**
 * Ürün adını rapor grubuna indirger.
 * @param {string} name ham ürün adı (log.productName)
 * @returns {string} "Çay" | "Filtre Kahve" | "Türk Kahvesi" | "Espresso" | "-"
 */
export const groupConsumptionProduct = (name) => {
  const raw = String(name ?? "").trim();
  // Boş/bilinmeyen ad Espresso'ya YAZILMAZ — olmayan bir tüketimi espresso
  // toplamına eklemek raporu sessizce şişirirdi.
  if (!raw || raw === "-") return "-";

  const lower = raw.toLocaleLowerCase("tr");
  const match = CORE_CONSUMPTION_PRODUCTS.find(
    (p) => p.toLocaleLowerCase("tr") === lower,
  );
  return match || ESPRESSO_GROUP_LABEL;
};

/**
 * Firma, seçilen ürün için raporlanabilir mi?
 *
 * Rapor sayfalarında ürün seçimi firma listesini daraltır (kullanıcı kararı
 * 2026-08-28): firmada o ürün TANIMLI DEĞİLSE ya da ürün ayarı PASİF ise
 * (`quotaDistribution === false`) firma listede çıkmaz.
 *
 * KANITLANMADIKÇA GİZLEME (2026-08-28 düzeltmesi): ilk sürüm, ürün bilgisi
 * OKUNAMAYAN firmayı da eliyordu ve liste tamamen boş kalıyordu. `Firm.productInfo`
 * bir ref'tir ve varsayılanı `null` — ProductFirm kaydı olmayan firmada populate
 * null döner. Artık firma yalnızca ürün listesi GERÇEKTEN okunabildiğinde ve o
 * listede eşleşen aktif ürün yokken elenir; okunamıyorsa listede kalır.
 * Yanlışlıkla listede duran firma en kötü boş rapor üretir, gizlenen firma ise
 * raporu hiç alınamaz hale getirir.
 *
 * İki veri kaynağı denenir:
 *   1) `productInfo.productInfo[]` — ürün adı + `quotaDistribution` (tam bilgi)
 *   2) `quotaArray[]` — yalnızca ürün adı (getFirms yanıtındaki özet); aktiflik
 *      bilgisi yoktur, bu yüzden sadece VARLIK kontrolü yapılır. Sunucu bu
 *      diziyi her firma için üretip pasif ürünleri kendisi eler; BOŞ dizi
 *      "aktif ürünü yok" anlamına gelir ve firma elenir.
 *
 * Espresso özel: gerçek bir ürün adı değil, "üç temel ürün dışındaki her şey"
 * kuralının adı (sunucu: modules/product/domain/espresso.js). Bu yüzden
 * karşılaştırma ham adla değil GRUP adıyla yapılır — firmadaki "Cappuccino" gibi
 * bir içecek adı da Espresso seçimini karşılar.
 *
 * @param {object} firm firma kaydı (getFirms yanıtından)
 * @param {string} productName seçili ürün (temel ürün ya da "Espresso")
 * @returns {boolean}
 */
export const firmHasActiveProduct = (firm, productName) => {
  const target = String(productName || "").trim();
  // Ürün seçilmemişse eleme yapılmaz — liste olduğu gibi kalır.
  if (!target) return true;

  const targetGroup = groupConsumptionProduct(target);

  // 1) Tam bilgi: ürün adı + aktiflik bayrağı
  const items = firm?.productInfo?.productInfo;
  if (Array.isArray(items) && items.length > 0) {
    return items.some((item) => {
      if (item?.quotaDistribution === false) return false;
      return groupConsumptionProduct(item?.productName) === targetGroup;
    });
  }

  // 2) Özet: ürün adları var, aktiflik bilgisi yok -> varlık kontrolü.
  //
  // BOŞ DİZİ DE BİR CEVAPTIR (2026-09-14 düzeltmesi): önce `length > 0`
  // aranıyordu, yani "ürünü hiç olmayan firma" ile "ürün bilgisi okunamayan
  // firma" aynı kefeye giriyor ve ikisi de listede kalıyordu. Sunucu
  // `getFirms` yanıtında `quotaArray`i HER firma için üretir (pasif ürünleri
  // kendisi eler), dolayısıyla boş dizi "bu firmanın aktif ürünü yok"
  // demektir — firma listeden düşer.
  const quotaArray = firm?.quotaArray;
  if (Array.isArray(quotaArray)) {
    return quotaArray.some(
      (q) => groupConsumptionProduct(q?.name) === targetGroup,
    );
  }

  // 3) İki kaynak da YOK (alan hiç gelmemiş) -> eleme YAPMA.
  // Gerçekten okunamayan durumda firma listede kalır: yanlışlıkla listede
  // duran firma en kötü boş rapor üretir, gizlenen firma ise raporu hiç
  // alınamaz hale getirir.
  return true;
};
